module.exports = __webpack_public_path__ + "facelifting_3_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/facelifting_3_before_tn.jpg
// module id = 1522
// module chunks = 0